export default __webpack_public_path__ + "static/media/Morana.8f8ec052.png";